<template>
  <div class="container" v-if="pedido != null">
    <div class="row">
      <!-- Columna Datos del pedido -->
      <div class="col-4">
        <h5 class="header text-center">
          Pedido
          <i>({{ pedido.id | pedido_id2folio }})</i>
        </h5>
        <table class="table table-striped table-bordered">
          <tbody>
            <tr>
              <td>Estado</td>
              <td class="text-right text-capitalize" :class="pedido.estado">
                {{ pedido.estado }}
              </td>
            </tr>
            <tr>
              <td>Monto</td>
              <td class="text-right font-weight-bold">
                {{ pedido.total | moneda }}
              </td>
            </tr>
            <tr>
              <td>Fecha de solicitud</td>
              <td class="text-right">{{ pedido.created | dateTime }}</td>
            </tr>
            <tr>
              <td>Fecha de Asignación</td>
              <td class="text-right">{{ pedido.produccion | dateTime }}</td>
            </tr>
            <tr>
              <td>Fecha de Entrega</td>
              <td class="text-right">{{ pedido.fecha_reparto | dateTime }}</td>
            </tr>
            <tr>
              <td>Repartidor:</td>
              <td class="text-right" style="padding:0">
                <a
                  :href="'/repartidores/ver/' + pedido.cobrador_id"
                  class="btn btn-primary btn-block"
                >
                  {{ pedido.cobrador_nombre }}
                  <span class="badge badge-pill badge-light">
                    {{ pedido.cobrador_id }}
                  </span>
                </a>
              </td>
            </tr>
            <tr>
              <td>Asignado por:</td>
              <td class="text-right">
                {{ pedido.asignador_nombre }}
                <span class="badge badge-pill badge-danger">
                  {{ pedido.cobrador_id }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Columna Datos del pedido -->
      <div class="col-8">
        <h5 class="header text-center">
          Productos
          <i>( {{ pedido.items.length }})</i>
        </h5>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Producto</th>
              <th class="text-right">Cantidad</th>
              <th>Unid</th>
              <th class="text-right">Precio</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in pedido.items" :key="i">
              <td>{{ item.producto.nombre }}</td>
              <td class="text-right">{{ item.cantidad }}</td>
              <td>{{ item.producto.unit_medida }}</td>
              <td class="text-right">{{ item.precio | moneda }}</td>
              <td class="text-right">
                {{ (item.precio * item.cantidad) | moneda }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4" class="text-right">Suma:</td>
              <td class="text-right font-weight-bold">
                {{ suma_total | moneda }}
              </td>
            </tr>
          </tfoot>
        </table>
        <h5 class="header text-center">
          Cliente
          <i>( {{ pedido.cliente.name }})</i>
        </h5>
        <p><b>Telefono:</b> {{ pedido.cliente.email }}</p>
      </div>
    </div>
    <!-- end row -->
    <!-- Mapa  -->
    <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height:400px;width:100%;border:5px solid #ddd;border-radius:5px"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="withPopup" :icon="icon">
        <l-popup>
          <div>
            <h5>Ver en google Maps:</h5>
            <a
              :href="link_google_maps()"
              target="_blank"
              class="btn btn-primary btn-block"
              style="color:#FFF"
            >
              <i class="fas fa-external-link-alt"></i>
              Abrir en Google Maps
            </a>
            <a
              :href="link_openstreet()"
              target="_blank"
              class="btn btn-success btn-block"
              style="color:#FFF"
            >
              <i class="fas fa-external-link-alt"></i>
              Abrir en openStreet
            </a>
          </div>
        </l-popup>
      </l-marker>
      <l-control id="direccion-data">
        <h5>Dirección:</h5>
        <p>
          {{ pedido.direccion.calle }}, Colonia {{ pedido.direccion.colonia }},
        </p>
        <p>Municipio: {{ pedido.direccion.municipio }},</p>
        <p>C.P. {{ pedido.direccion.cp }}</p>
        <a
          :href="link_google_maps()"
          target="_blank"
          class="btn btn-primary btn-block"
          style="color:#FFF"
        >
          <i class="fas fa-external-link-alt"></i>
          Abrir en GoogleMaps
        </a>
        <a
          :href="link_openstreet()"
          target="_blank"
          class="btn btn-success btn-block"
          style="color:#FFF"
        >
          <i class="fas fa-external-link-alt"></i>
          Abrir en openStreet
        </a>
      </l-control>
    </l-map>
    <!-- Mapa  -->
    <hr />
  </div>
  <div class="container" v-else>
    <h1 class="text-center">
      <b-spinner label="Loading..."></b-spinner>
      Cargando Datos
    </h1>
  </div>
</template>

<style lang="scss" scoped>
.produccion,
.reparto,
.cobro,
.finalizado {
  color: white;
  background: #666;
  /* padding: 0.375rem 0.75rem !important; */
}

.produccion {
  background: linear-gradient(90deg, #c45900, #e01818);
}
.reparto {
  background: linear-gradient(90deg, #a21525, #820917);
}
.cobro {
  background: linear-gradient(90deg, #800097, #600f6f);
}
.finalizado {
  background: linear-gradient(90deg, #048cec, #043cec);
}
/*        */
table.table tfoot td {
  background-color: #831d19;
  color: #fff;
}

.leaflet-right .leaflet-control {
  background: #eee;
  padding: 5px;
  border: 3px solid #ddd;
}
</style>

<script>
import { latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LControl, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

import PedidoApi from "../../apis/Pedido";

export default {
  name: "PedidoVer",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup
  },
  data() {
    return {
      pedido: null,
      suma_total: 0,
      // Datos mapa
      zoom: 13,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      center: null,
      withPopup: null,
      currentCenter: null,
      mapOptions: {
        zoomSnap: 0.5
      },
      icon: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("../../assets/marker.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [27, 35],
        iconAnchor: [27, 35]
      })
      // Datos mapa
    };
  },
  created() {
    PedidoApi.ver(this.$route.params.id).then(d => {
      this.pedido = d.data;
      for (let i in this.pedido.items) {
        this.suma_total +=
          parseInt(this.pedido.items[i].cantidad) *
          parseFloat(this.pedido.items[i].precio);
        // ---
        let gps = latLng(this.pedido.direccion.lat, this.pedido.direccion.lng);
        this.center = gps;
        this.withPopup = gps;
        this.currentCenter = gps;
        // ---
      }
    });
    /*UserApi.repartidor_ver(this.$route.params.id).then(d => {
      this.repartidor = d.data;
    });*/
  },
  methods: {
    link_openstreet: function() {
      let la = this.pedido.direccion.lat;
      let lo = this.pedido.direccion.lng;
      return `https://www.openstreetmap.org/?mlat=${la}&mlon=${lo}`;
    },
    link_google_maps: function() {
      let la = this.pedido.direccion.lat;
      let lo = this.pedido.direccion.lng;
      return `https://www.google.com/maps/search/?api=1&query=${la},${lo}`;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    }
  }, // end methods
  computed: {}
};
</script>
